<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active"><a href="javascript:;">Product</a></li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('product_header_name') }} <!--<small class="ml-2">{{ this.$t('product_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:user="user"
						:checkRole="checkRole"
						:products="products"
						:product="product"
						:status="status"
						:syncProductsCall="syncProductsCall"
						:syncDisabled="syncDisabled"
						:showSyncModal="showSyncModal"
						:closeSyncModal="closeSyncModal"
						:translateUnit="translateUnit"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
    name: 'Product',
	components: {
		PageContentContainer,
	},
    props: [
		'checkRole',
		'user',
	],
	data() {
		return {
			syncDisabled: false,
			showSyncModal: false,
		}
	},
    computed: {
        ...mapState('product', ['products', 'product', 'status']),
    },
    methods: {
		...mapActions('product', ['getProducts', 'getProduct', 'syncProducts']),
		syncProductsCall() {
			this.syncDisabled = true;
			this.syncProducts();
		},
		closeSyncModal() {
			this.showSyncModal = false;
		},
		translateUnit(unit) {
			switch (unit) {
				case 'NO_UNIT':
					return this.$t('task_unit_none')
				case 'PIECE':
					return this.$t('task_unit_piece')
				case 'LITER':
					return this.$t('task_unit_liter')
				default:
					return unit
			}
		},
    },
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
    mounted() {
		if (!this.products.length) {
			this.getProducts();
		}
		if (this.$route.params.id) {
			this.getProduct(this.$route.params.id);
		}
    },
	watch: {
		products() {
			if (this.products && this.products.sync) {
				this.syncDisabled = false;
				this.showSyncModal = true;
			}
		},
	},
}
</script>
